module.exports = __webpack_public_path__ + "static/media/concert-0.small.0380b4dd.png";